import React, { useEffect, useState } from "react";
import { firestore } from "../../db/config";

export default function LatestTransactions() {
  const [latesDeposit, setlatesDeposit] = useState([]);
  const [latestWithDraw, setlatestWithDraw] = useState([]);
  useEffect(() => {
    let arrayDepo = [];
    firestore.collection("latestDeposit").onSnapshot((snapShot) => {
      const getDepo = snapShot.docs.map((depo) => depo.data());
      // arrayDepo.push(getDepo);
      setlatesDeposit(getDepo);
    });
    firestore.collection("latestWithDraw").onSnapshot((snapShot) => {
      const getDepo = snapShot.docs.map((depo) => depo.data());
      // arrayDepo.push(getDepo);
      setlatestWithDraw(getDepo);
    });
  }, []);

  return (
    <div>
      <div class="transaction_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="sv_heading_wraper half_section_headign half_sec_heading">
                {/* <h4>who we are</h4> */}
                <h3>Our Latest Transaction</h3>
              </div>
              <div class="x_offer_tabs_wrapper">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    {" "}
                    <a class="nav-link active" data-toggle="tab" href="#home">
                      {" "}
                      deposits
                    </a>
                  </li>
                  <li class="nav-item">
                    {" "}
                    <a class="nav-link" data-toggle="tab" href="#menu2">
                      withdraw
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12">
              <div class="tab-content">
                <div id="home" class="tab-pane active">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="table_next_race league_table overflow-scroll">
                        <table>
                          <tr>
                            <th class="form_table_resp">name</th>
                            <th>date</th>
                            <th>amount</th>
                            <th>currency</th>
                            <th>deposit</th>
                          </tr>

                          {latesDeposit.length
                            ? latesDeposit.map((depo, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <img
                                        src="images/cash-deposit.png"
                                        alt="img"
                                        style={{ height: "50px" }}
                                      />{" "}
                                      <span>{depo.Name}</span>
                                    </td>

                                    <td>{depo.Date}</td>
                                    <td>${depo.Amount}</td>
                                    <td>{depo.Currency}</td>
                                    <td>{depo.Deposit}</td>
                                  </tr>
                                );
                              })
                            : ""}

                          {/* <tr>
                            <td>
                              <img src="images/mem4.png" alt="img" />{" "}
                              <span>Nancee Broom</span>
                            </td>

                            <td>June 04,2019</td>
                            <td>$16,00,000.00</td>
                            <td>card</td>
                            <td>22 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem1.png" alt="img" />{" "}
                              <span>Broom Nancee</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$6,00,000.00</td>
                            <td>bitcoin</td>
                            <td>15 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem2.png" alt="img" />{" "}
                              <span>Ripple Alison</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$06,00,000.00</td>
                            <td>ripees</td>
                            <td>05 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem2.png" alt="img" />{" "}
                              <span>Ripple Alison</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$06,00,000.00</td>
                            <td>ripees</td>
                            <td>05 Minutes Ago</td>
                          </tr> */}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="menu2" class="tab-pane fade">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="table_next_race league_table overflow-scroll">
                        <table>
                          <tr>
                            <th class="form_table_resp">name</th>
                            <th>date</th>
                            <th>amount</th>
                            <th>currency</th>
                            <th>deposit</th>
                          </tr>
                          {latestWithDraw.length
                            ? latestWithDraw.map((depo, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <img
                                        src="images/abt_img.jpg"
                                        alt="img"
                                        style={{ height: "50px" }}
                                      />{" "}
                                      <span>{depo.Name}</span>
                                    </td>

                                    <td>{depo.Date}</td>
                                    <td>${depo.Amount}</td>
                                    <td>{depo.Currency}</td>
                                    <td>{depo.Deposit}</td>
                                  </tr>
                                );
                              })
                            : ""}
                          {/* <tr>
                            <td>
                              <img src="images/mem4.png" alt="img" />{" "}
                              <span>Nancee Broom</span>
                            </td>

                            <td>June 04,2019</td>
                            <td>$16,00,000.00</td>
                            <td>card</td>
                            <td>22 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem1.png" alt="img" />{" "}
                              <span>Olympia Ripple</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$6,00,000.00</td>
                            <td>Dollar</td>
                            <td>03 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem2.png" alt="img" />{" "}
                              <span>Ripple Alison</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$06,00,000.00</td>
                            <td>ripees</td>
                            <td>05 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem6.png" alt="img" />{" "}
                              <span>Emmett Stein</span>
                            </td>
                            <td>June 21,2019</td>
                            <td>$66,00,000.00</td>
                            <td>paypal</td>
                            <td>53 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem1.png" alt="img" />{" "}
                              <span>Broom Nancee</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$6,00,000.00</td>
                            <td>bitcoin</td>
                            <td>15 Minutes Ago</td>
                          </tr>

                          <tr>
                            <td>
                              <img src="images/mem4.png" alt="img" />{" "}
                              <span>Alison Rittichier</span>
                            </td>

                            <td>June 28,2019</td>
                            <td>$77,00,000.00</td>
                            <td>payonner</td>
                            <td>05 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem3.png" alt="img" />{" "}
                              <span>Olympia Ripple</span>
                            </td>

                            <td>June 05,2019</td>
                            <td>$45,00,000.00</td>
                            <td>ETH</td>
                            <td>13 Minutes Ago</td>
                          </tr>
                          <tr>
                            <td>
                              <img src="images/mem5.png" alt="img" />{" "}
                              <span>Olympia Ripple</span>
                            </td>

                            <td>June 24,2019</td>
                            <td>$11,00,000.00</td>
                            <td>card</td>
                            <td>23 Minutes Ago</td>
                          </tr> */}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
